module.exports = __webpack_public_path__ + "img/test1-1.bda93edb.jpg";